import { Component, ElementRef, OnInit } from '@angular/core';
import { AccountType } from '@ee/common/enums';
import { environment } from '../environments/environment';
import {Product} from '@ee/common/pricing/models/product.model';
import {Price} from '@ee/common/pricing/models/price.model';

@Component({
  selector: 'ee-pricing',
  template: `
    <div class="ee-pricing landing-container pricing auth-container flex flex-col">
      <ee-pricing-table [type]="selectedType" (selectPlan)="planSelected($event)"></ee-pricing-table>
    </div>
  `,
  styles: [
    `
      .ee-pricing {
        font-family: 'Barlow', sans-serif;
        margin: 0;
        padding: 0;

        .landing-container {
          padding-bottom: 30px;
        }

        .mat-toolbar.header {
          z-index: 100;
        }

        .step-name {
          font-size: 1rem;
          font-weight: bold;
        }

        h1 {
          font-weight: 600;
        }

        h2 {
          font-weight: 700;
          font-size: 1.5rem;

          &.main-header {
            font-weight: 600;

            &.top {
              margin-top: 16px;
            }
          }
        }

        .dates {
          font-size: 1rem;

          b {
            line-height: 10px;
            font-weight: 500;
          }
        }
      }
    `
  ],
  standalone: false
})
export class AttorneyComponent implements OnInit {
  public selectedType: AccountType;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.selectedType = AccountType[this.elementRef.nativeElement.getAttribute('type')];
  }

  planSelected(selectedPlan: {product: Product, price: Price}) {
    if (selectedPlan.product.button_link) {
      window.location.href = selectedPlan.product.button_link;
    } else {
      // opens a new tab to the calendly link
      window.open(environment.book_demo_url, '_blank');
    }
  }
}
